var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTarget(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 32.0088C25.732 32.0088 32 25.7408 32 18.0088C32 10.2768 25.732 4.00879 18 4.00879C10.268 4.00879 4 10.2768 4 18.0088C4 25.7408 10.268 32.0088 18 32.0088ZM18 36.0088C27.9411 36.0088 36 27.9499 36 18.0088C36 8.06766 27.9411 0.00878906 18 0.00878906C8.05887 0.00878906 0 8.06766 0 18.0088C0 27.9499 8.05887 36.0088 18 36.0088Z",
    fill: "#222222"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 24.0088C21.3137 24.0088 24 21.3225 24 18.0088C24 14.6951 21.3137 12.0088 18 12.0088C14.6863 12.0088 12 14.6951 12 18.0088C12 21.3225 14.6863 24.0088 18 24.0088ZM18 28.0088C23.5228 28.0088 28 23.5316 28 18.0088C28 12.4859 23.5228 8.00879 18 8.00879C12.4772 8.00879 8 12.4859 8 18.0088C8 23.5316 12.4772 28.0088 18 28.0088Z",
    fill: "#222222"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTarget);
export default __webpack_public_path__ + "static/media/target.a7457f82c8ed04a3ed9f5c5a3b549872.svg";
export { ForwardRef as ReactComponent };